var _mask, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWiki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "wiki-icon_svg__mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.8033C0 5.28451 5.2852 0 11.8048 0C18.3244 0 23.6096 5.28451 23.6096 11.8033C23.6096 18.3221 18.3244 23.6066 11.8048 23.6066C5.2852 23.6066 0 18.3221 0 11.8033Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#wiki-icon_svg__mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11.8033C0.5 5.56071 5.56128 0.5 11.8048 0.5C18.0484 0.5 23.1096 5.56071 23.1096 11.8033C23.1096 18.0458 18.0484 23.1066 11.8048 23.1066C5.56128 23.1066 0.5 18.0458 0.5 11.8033Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11.8033C0.5 5.56071 5.56128 0.5 11.8048 0.5C18.0484 0.5 23.1096 5.56071 23.1096 11.8033C23.1096 18.0458 18.0484 23.1066 11.8048 23.1066C5.56128 23.1066 0.5 18.0458 0.5 11.8033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11.8033C0.5 5.56071 5.56128 0.5 11.8048 0.5C18.0484 0.5 23.1096 5.56071 23.1096 11.8033C23.1096 18.0458 18.0484 23.1066 11.8048 23.1066C5.56128 23.1066 0.5 18.0458 0.5 11.8033Z",
    stroke: "#D2D2D2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.45C18 9.525 17.9236 9.6 17.8471 9.6H17.1592L13.8726 16.425C13.8726 16.5 13.7962 16.5 13.7197 16.5C13.6433 16.5 13.6433 16.5 13.5669 16.425L12.0382 13.425L10.3567 16.425C10.4331 16.5 10.3567 16.5 10.3567 16.5C10.2803 16.5 10.2803 16.5 10.2038 16.425L6.9172 9.6H6.15287C6.07643 9.6 6 9.525 6 9.45V9.15C6.07643 9.075 6.07643 9 6.15287 9H8.82803C8.90446 9 8.98089 9.075 8.98089 9.15V9.525C8.98089 9.6 8.90446 9.675 8.82803 9.675H8.29299L10.586 14.85L11.8089 12.675L10.2803 9.675H9.89809C9.82166 9.6 9.74522 9.525 9.74522 9.45V9.15C9.74522 9.075 9.82166 9 9.89809 9H11.8854C11.9618 9 12.0382 9.075 12.0382 9.15V9.525C12.0382 9.6 11.9618 9.675 11.8854 9.675H11.5032L12.344 11.55L13.3376 9.675H12.7261C12.6497 9.675 12.5733 9.6 12.5733 9.525V9.15C12.5733 9.075 12.6497 9 12.7261 9H14.6369C14.7134 9 14.7898 9.075 14.7898 9.15V9.525C14.7898 9.6 14.7134 9.675 14.6369 9.675H14.2548L12.7261 12.375L13.949 14.85L16.3185 9.675H15.5541C15.4777 9.675 15.4013 9.6 15.4013 9.525V9.15C15.4013 9.075 15.4777 9 15.5541 9H17.8471C17.9236 9 18 9.075 18 9.15V9.45Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiki);
export default __webpack_public_path__ + "static/media/wiki.fa327758f1d8f1b605b919c37457b181.svg";
export { ForwardRef as ReactComponent };